module.exports = __webpack_public_path__ + "img/cover5.def0ad4f.png";